import { create } from 'zustand';

interface SimulationState {
  isSimulating: boolean;
  simulatedGln: string | null;
  simulatedCompanyName: string | null;
  startSimulation: (gln: string, companyName: string) => void;
  stopSimulation: () => void;
}

export const useSimulationStore = create<SimulationState>((set) => ({
  isSimulating: false,
  simulatedGln: null,
  simulatedCompanyName: null,
  startSimulation: (gln, companyName) =>
    set({
      isSimulating: true,
      simulatedGln: gln,
      simulatedCompanyName: companyName,
    }),
  stopSimulation: () =>
    set({
      isSimulating: false,
      simulatedGln: null,
      simulatedCompanyName: null,
    }),
}));

export function useIsSimulating(): boolean {
  return useSimulationStore((s) => s.isSimulating);
}
